"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _Modal = require("./Modal");

var _ModalHeader = require("./ModalHeader");

var _ModalBody = require("./ModalBody");

var _ModalFooter = require("./ModalFooter");

var _Button = _interopRequireDefault(require("../Button"));

var _classnames = _interopRequireDefault(require("classnames"));

var DefaultModalFooter = function DefaultModalFooter(_ref) {
  var handleConfirmation = _ref.handleConfirmation,
      onClose = _ref.onClose,
      action = _ref.action,
      variant = _ref.variant;
  return (0, _preact.h)(_ModalFooter.ModalFooter, null, (0, _preact.h)(_Button.default, {
    title: action,
    variant: variant,
    onClick: handleConfirmation,
    size: "medium"
  }), (0, _preact.h)(_Button.default, {
    title: "Cancel",
    onClick: onClose,
    size: "medium"
  }));
};

var ConfirmationModal = function ConfirmationModal(_ref2) {
  var isOpen = _ref2.isOpen,
      withElevatedZIndex = _ref2.withElevatedZIndex,
      handleConfirmation = _ref2.handleConfirmation,
      onClose = _ref2.onClose,
      title = _ref2.title,
      body = _ref2.body,
      action = _ref2.action,
      variant = _ref2.variant,
      footer = _ref2.footer,
      theme = _ref2.theme,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'medium' : _ref2$size,
      _ref2$isControl = _ref2.isControl,
      isControl = _ref2$isControl === void 0 ? true : _ref2$isControl,
      _ref2$placement = _ref2.placement,
      placement = _ref2$placement === void 0 ? 'center' : _ref2$placement;
  return (0, _preact.h)(_Modal.Modal, {
    isOpen: isOpen,
    isControl: isControl,
    size: size,
    placement: placement,
    theme: theme,
    className: (0, _classnames.default)({
      'with-elevated-z-index': withElevatedZIndex
    })
  }, (0, _preact.h)(_ModalHeader.ModalHeader, {
    title: title,
    onClose: onClose
  }), (0, _preact.h)(_ModalBody.ModalBody, null, typeof body === 'string' ? (0, _preact.h)("p", null, body) : body), footer ? (0, _preact.h)(_ModalFooter.ModalFooter, null, footer) : (0, _preact.h)(DefaultModalFooter, {
    handleConfirmation: handleConfirmation,
    onClose: onClose,
    action: (0, _absoluteUrlRuntime.resolveUrl)(action),
    variant: variant
  }));
};

var _default = ConfirmationModal;
exports.default = _default;